export default __webpack_public_path__ + "static/MBMAORG-logo-efad290102e1c22a82c815bcd5cb9384.png";